import { DenominationType } from '../@types/denomination_type';
import axios from '../utils/axios';

export const fetchAllDenominationTypes = async (): Promise<DenominationType[]> => {
  const response = await axios.get('denomination-types');
  return response.data;
};
